import React from 'react';
import styled from 'styled-components';

import { Flex, Grid } from 'Components/Base';

export const ContentWrapper = (props) => {
  return <Grid gridTemplateColumns={{ _: '1fr', md: '1fr 1fr' }} gridGap={4} mt={6} {...props} />;
};

export const CardWrapper = styled((props) => {
  return <Flex flexDirection="column" px={6} py={4} {...props} />;
})`
  box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background-color: white;
`;
